/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Program_Audio_LabelInputs */

const en_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Audio (Optional)`)
};

const fr_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio du programme (optionnel)`)
};

const de_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm-Audio (optional)`)
};

const it_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio del programma (facoltativo)`)
};

const ru_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиопрограмма (необязательно)`)
};

const es_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio del programa (opcional)`)
};

const zh_cn2_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节目音频（可选）`)
};

const ja_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムオーディオ（オプション）`)
};

const hi_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम का ऑडियो (वैकल्पिक)`)
};

const pt_pt2_audio_description_export_program_audio_label = /** @type {(inputs: Audio_Description_Export_Program_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áudio do programa (opcional)`)
};

/**
* | output |
* | --- |
* | "Program Audio (Optional)" |
*
* @param {Audio_Description_Export_Program_Audio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_program_audio_label = /** @type {((inputs?: Audio_Description_Export_Program_Audio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Program_Audio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_program_audio_label(inputs)
	if (locale === "de") return de_audio_description_export_program_audio_label(inputs)
	if (locale === "it") return it_audio_description_export_program_audio_label(inputs)
	if (locale === "ru") return ru_audio_description_export_program_audio_label(inputs)
	if (locale === "es") return es_audio_description_export_program_audio_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_program_audio_label(inputs)
	if (locale === "ja") return ja_audio_description_export_program_audio_label(inputs)
	if (locale === "hi") return hi_audio_description_export_program_audio_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_program_audio_label(inputs)
	return en_audio_description_export_program_audio_label(inputs)
});